<template>
<v-card tile height="100%" >
  <v-card-title class='py-2 overline grey darken-4' >
    <!-- <v-btn @click="$emit('update:src', 'https://settings.appointmentguru.co/#/brand')" ></v-btn> -->
    <v-spacer/>
    <v-btn icon small dark @click="$emit('close')" >
      <v-icon small dark >close</v-icon>
    </v-btn>
  </v-card-title>
  <center v-if="loading" >
    <v-progress-circular indeterminate size="72" color="amber" class="mt-5" /><br/>
    Loading ..
  </center>
  <iframe
    v-show="!loading"
    id="settingsiframe"
    :src="src"
    @load="iframeloaded"
    frameborder="0"
    width="100%"
    height="100%" />
</v-card>
</template>
<script>
export default {
  name: 'AgIframe',
  props: {
    src: { type: String, required: true }
  },
  data () {
    return {
      loading: true
    }
  },
  watch: {
    src () { this.loading = true }
  },
  methods: {
    iframeloaded () {
      this.loading = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// AgIframe.vue?34b12a4e